export enum DocumentCalculationMethodEnum {
  KASS = 'KASS',
  SALE = 'SALE'
}
